import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { deepCopy } from 'src/app/shared/deep-copy';
import { MSG_PLEASE_CHECK } from 'src/app/shared/messages/general';

@Component({
  selector: 'month-year-selector',
  templateUrl: './month-year-selector.component.html',
  styleUrls: ['./month-year-selector.component.css']
})
export class MonthYearSelectorComponent {

  @Input()
  baseDate: Date = null;

  @Input()
  title: string = 'Monat/Jahr Auswählen';


  form = new FormGroup({
    month: new FormControl(),
    year: new FormControl()
  });

  months = [
    {label: 'Januar', value: 1},
    {label: 'Februar', value: 2}, 
    {label: 'März', value: 3}, 
    {label: 'April', value: 4}, 
    {label: 'Mai', value: 5}, 
    {label: 'Juni', value: 6}, 
    {label: 'Juli', value: 7}, 
    {label: 'August', value: 8}, 
    {label: 'September', value: 9}, 
    {label: 'Oktober', value: 10}, 
    {label: 'November', value: 11}, 
    {label: 'Dezember', value: 12}, 
  ];

  years = [];

  constructor(
    public modal: NgbActiveModal, private toast: ToastrService
  ) {}

  ngOnInit() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const searchDate = new Date();
    searchDate.setFullYear(currentDate.getFullYear() - 15);

    while (searchDate.getFullYear() <= currentYear) {
      this.years.push(searchDate.getFullYear());
      searchDate.setFullYear(searchDate.getFullYear() + 1);
    }
  }

  submit() {
    if (this.form.invalid) {
      this.toast.error(MSG_PLEASE_CHECK)
      return;
    }
    this.modal.close(deepCopy(this.form.value));
  }

}
